import all from './all';
import find from './find';

export default {
  all,
  find,
};



// WEBPACK FOOTER //
// ./src/app/services/transactionType/index.js